import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/input';

export function FieldGroup({
  label,
  body,
  tags,
}: {
  label: string;
  body?: string | null;
  tags?: string[] | null;
}) {
  if (!body && (!tags || tags.length === 0)) return null;
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      {body && <p className="whitespace-pre-wrap text-sm leading-relaxed">{body}</p>}
      {tags && tags.length > 0 && (
        <ul className="flex flex-wrap gap-1.5">
          {tags.map((t, i) => (
            <li key={i}>
              <Badge tone="neutral">{t}</Badge>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
